import I18n from 'I18n';
import { UNKNOWN_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import { eventTriggerStep } from 'automation-ui-canvas/create/steps/EventTriggerStep';
import { scheduledTriggerStep } from 'automation-ui-canvas/create/steps/ScheduledTriggerStep';
import { listTriggerStep } from 'automation-ui-canvas/create/steps/ListTriggerStep';
import { manualTriggerStep } from 'automation-ui-canvas/create/steps/ManualTriggerStep';
import { refinementCriteriaStep } from 'automation-ui-canvas/create/steps/RefinementCriteriaStep';
import { enrollmentSettingsStep } from 'automation-ui-canvas/create/steps/EnrollmentSettingsStep';
import { customPropertiesStep } from 'automation-ui-canvas/create/steps/CustomPropertiesStep';
import { objectTypeStep } from 'automation-ui-canvas/create/steps/ObjectTypeStep';
const selectTriggerStep = {
  getLabel: () => I18n.text('createWorkflow.step.selectTrigger')
};
export function getSteps({
  selectedTriggerOption,
  objectTypeId,
  isUngatedForObjectlessWorkflows,
  hasCustomProperties
}) {
  const {
    type
  } = selectedTriggerOption;
  const steps = [];
  if (type === 'EVENT' || type === 'WEBHOOK') {
    steps.push(eventTriggerStep, refinementCriteriaStep, enrollmentSettingsStep);
  } else if (type === 'LIST') {
    steps.push(selectTriggerStep, objectTypeStep, listTriggerStep, enrollmentSettingsStep);
  } else if (type === 'MANUAL') {
    steps.push(selectTriggerStep, manualTriggerStep, enrollmentSettingsStep);
  } else if (type === 'SCHEDULED') {
    if (isUngatedForObjectlessWorkflows && objectTypeId === UNKNOWN_ID) {
      steps.push(scheduledTriggerStep);
    } else {
      steps.push(scheduledTriggerStep, refinementCriteriaStep, enrollmentSettingsStep);
    }
  }
  if (hasCustomProperties) {
    steps.push(customPropertiesStep);
  }
  return steps;
}